export const toKM = (num: number) => {
  return new Intl.NumberFormat("de-DE", {
    style: "unit",
    //@ts-ignore
    unit: "kilometer-per-hour",
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  }).format(num);
};
